import { Injectable } from '@angular/core';
import {app,authentication,appInitialization} from '@microsoft/teams-js';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {
  private teamsContext: app.Context | null = null;
  private isInTeams = false;

  constructor(private msalService: MsalService) {}

  /**
   * Initialize Teams SDK
   */
  async initialize(): Promise<boolean> {
    try {
      await app.initialize();
       console.log('Teams SDK initialized successfully..');
      this.isInTeams = true;
      
      // // Get Teams context
      this.teamsContext = await app?.getContext();
      
      // // Notify Teams that app is ready
      app.notifySuccess();
      
      console.log('Teams SDK initialized successfully');
      //console.log('Teams SDK initialized successfully', this.teamsContext);
      return true;
    } catch (error) {
      //alert('Not running in Teams environment or initialization failed: ' + error);
      console.log('Not running in Teams environment or initialization failed', error);
      this.isInTeams = false;
      return false;
    }
  }

  /**
   * Check if the app is running in Teams
   */
  isRunningInTeams(): boolean {
    return this.isInTeams;
  }

  /**
   * Get Teams context
   */
  getContext(): app.Context | null {
    return this.teamsContext;
  }

  /**
   * Authenticate using Teams SSO with MSAL integration
   */
  async authenticateWithTeamsSSO(): Promise<boolean> {
    if (!this.isInTeams) {
      return false;
    }

    try {
      // Get Teams SSO token - must match the resource in manifest.json
      const teamsToken = await authentication.getAuthToken({
        //resources: ['https://myltts.ltts.com'],
        silent: true,  // Use popup for explicit consent
        
      }).then((result) => {
        appInitialization.notifySuccess()
        return result;
      }).catch((error) => {
        throw error;
      });
      console.log('[TeamsService] Teams SSO token obtained');
      
      // Store in sessionStorage for TokenService to use
      sessionStorage.setItem('teams_sso_token', teamsToken);
      
      // Decode JWT to get expiry
      const payload = JSON.parse(atob(teamsToken.split('.')[1]));
      sessionStorage.setItem('teams_sso_expiry', payload.exp);
      
      console.log('[TeamsService] Token stored, expiry:', new Date(payload.exp * 1000));
      return true;
    } catch (error) {
      console.error('Teams SSO authentication failed', error);
      return false;
    }
  }

  /**
   * Open authentication popup
   */
  async authenticate(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      authentication.authenticate({
        url: url,
        width: 600,
        height: 535
      }).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}

